import type { TourStep } from "../tour-steps";

// Blocos dos roteiros do tour global. Todo passo mora em /inicio: o tour não navega.

export const boasVindas = (titulo: string, texto: string): TourStep => ({
  id: "boas-vindas",
  route: "/inicio",
  target: "body",
  placement: "center",
  title: titulo,
  content: texto,
  skipBeacon: true,
});

type Area = {
  id: string;
  /** data-tour do item no menu lateral (desktop). */
  menu: string;
  /** data-tour da aba de baixo no celular, quando a área tem aba. */
  aba?: string;
  /** Onde achar no celular quando não há aba. Padrão: Menu › {nome}. */
  noCelular?: string;
  nome: string;
  titulo: string;
  texto: string;
};

/** Uma área do produto: o item do menu lateral no desktop; no celular, a aba ou a instrução. */
export function area(celular: boolean, a: Area): TourStep {
  const base = { id: a.id, route: "/inicio", title: a.titulo, skipBeacon: true as const };
  if (!celular) return { ...base, target: `[data-tour="${a.menu}"]`, placement: "right", isFixed: true, content: a.texto };
  if (a.aba) return { ...base, target: `[data-tour="${a.aba}"]`, placement: "top", isFixed: true, content: a.texto };
  const onde = a.noCelular ?? `toque em Menu, na barra de baixo, e depois em ${a.nome}`;
  return { ...base, target: "body", placement: "center", content: `${a.texto} No celular, ${onde}.` };
}

export const ajudaFinal = (): TourStep => ({
  id: "ajuda",
  route: "/inicio",
  target: '[data-tour="botao-ajuda"]',
  placement: "top-end",
  isFixed: true,
  title: "Ajuda em toda tela",
  content:
    "Em qualquer página, o botão Ajuda explica como ela funciona, passo a passo, e abre o tour daquela tela quando houver. Os diálogos também têm um ? ao lado do título. Este tour você refaz pelo menu do seu perfil, em Conheça a plataforma.",
  skipBeacon: true,
});

export const EQUIPE = (celular: boolean, aba?: string) =>
  area(celular, {
    id: "equipe",
    menu: "sidebar-equipe",
    aba,
    nome: "Equipe",
    titulo: "Equipe e acessos",
    texto: "Convide quem trabalha com você e escolha o que cada pessoa pode ver e fazer. Dentistas e protéticos também ganham aqui as especialidades e os procedimentos que atendem.",
  });

/** Na clínica (e na híbrida) a Equipe mora dentro de Minha clínica, junto das salas. */
export const MINHA_CLINICA = (celular: boolean) =>
  area(celular, {
    id: "minha-clinica",
    menu: "sidebar-minha-clinica",
    nome: "Minha clínica",
    titulo: "Salas e equipe",
    texto: "Em Minha clínica ficam as salas (quem está em cada cadeira agora, a planta e o modo recepção) e a equipe: convide quem trabalha com você e escolha o que cada pessoa pode ver e fazer.",
  });

export const CONFIGURACOES = (celular: boolean) =>
  area(celular, {
    id: "configuracoes",
    menu: "sidebar-configuracoes",
    nome: "Configurações",
    noCelular: "toque na sua foto, no alto, e depois em Configurações",
    titulo: "Configurações da organização",
    texto: "Dados e endereço, expediente, área de atuação, agenda, permissões de cada papel e importação de dados. Ajuste uma vez e vale para toda a equipe.",
  });
